import { Box, Container, Grid, Paper, styled } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class ConsultasSaldosUsuario extends Component {
    constructor(props){
        super(props);
        this.state = {
            atras: false,
            diasTurismo: {},
            horasInhabile: {},
            horasSimples: {},
            acta: {},
            reglamentaria: [],
            anti: [],
            ley: {},
            enfermedadFamiliar: {},
            estudio: {},
            internacion: {},
            especial: {},
            suspendida: {},
            nombreUsu: '',
            covid: '',
            busqueda: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
            },
        }
        this.manejarAtras = this.manejarAtras.bind(this);
    }

    async componentDidMount(){
        const carga = JSON.stringify(['', sessionStorage.numeroFuncionario]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_licencia.php`,{
            method: 'POST',
            body: carga,
        })
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_resumenSaldos.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datosInfoSol = await infoSol.json();
        if(datosInfoSol.length !== 0){
            
            if(sessionStorage.presupuestado === 'SI'){
                this.setState({
                    diasTurismo: {
                        diasTotal: 0,
                    },
                    horasInhabile: datosInfoSol[1],
                    acta: {
                        diasTotal: 0,
                    },
                    reglamentaria: datosInfoSol[3],
                    anti: datosInfoSol[4],
                    ley: datosInfoSol[5],
                    enfermedadFamiliar: {
                        diasTotal: 0,
                    },
                    estudio: datosInfoSol[7],
                    internacion: {
                        diasTotal: 0,
                    },
                    especial: {
                        diasTotal: 0,
                    },
                    nombreUsu: datosInfoSol[10],
                    horasSimples: {
                        horasTotal: 0,
                    },
                    covid: {
                        diasTotal: 0,
                    },
                    suspendida: datosInfoSol[13]
                });
            }else{
                this.setState({
                    diasTurismo: datosInfoSol[0],
                    horasInhabile: datosInfoSol[1],
                    acta: datosInfoSol[2],
                    reglamentaria: datosInfoSol[3],
                    anti: datosInfoSol[4],
                    ley: datosInfoSol[5],
                    enfermedadFamiliar: datosInfoSol[6],
                    estudio: datosInfoSol[7],
                    internacion: datosInfoSol[8],
                    especial: datosInfoSol[9],
                    nombreUsu: datosInfoSol[10],
                    horasSimples: datosInfoSol[11],
                    covid: datosInfoSol[12],
                    suspendida: datosInfoSol[13],
                });
            }
        }
    }

    render(){
        return (
            <>
                {sessionStorage.login && sessionStorage.tipoUsuario === '2'
                ?
                    <Container>
                        <h3>Saldos Disponibles</h3>
                        {this.state.especial.diasTotal > 0 ? <h5 style={{color:'red'}}> Por Acta 1.993 de fecha 12/04/2011, la Comisión Honoraria otorgó 5 días corridos de licencia extraordinaria, a usufructuar por única vez, en el año inmediato siguiente a cumplidos los 30 años de trabajo en la Institución, debiendose tomar los mismos antes del 31 de diciembre.</h5> : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        <br/>
                        {this.state.atras
                        ?
                            <Redirect to='/Consultas'/>
                        :
                            null
                        }
                        <fieldset>
                            <legend>{this.state.nombreUsu}</legend>
                            <legend>REGLAMENTARIA</legend>
                            {this.state.suspendida != null
                            ?
                                <Box sx={{ flexGrow: 1}}>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item style={{color: 'red'}}>LICENCIA REGLAMENTARIA SUSPENDIDA</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.suspendida.totalDias}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item style={{color: 'red'}}>EJERCICIO</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{this.state.suspendida.ejercicio}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                    </Grid>
                                    <br/>
                                </Box>
                            :
                                null
                            }
                            {this.state.reglamentaria.map((name, index) => (
                                <Box sx={{ flexGrow: 1}} key={index}>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={1}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>LICENCIA REGLAMENTARIA</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{name.diasDisponibles}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>EJERCICIO</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{name.anio}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                    </Grid>
                                    <br/>
                                </Box>
                            ))}
                            {this.state.anti.map((name, index) => (
                                <Box sx={{ flexGrow: 1}} key={index}>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={1}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>ANTIGÜEDAD</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{name.diasDisponibles}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>EJERCICIO</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>{name.anio}</Item>
                                        </Grid>
                                        <Grid item xs={0.5}>
                                            
                                        </Grid>
                                    </Grid>
                                    <br/>
                                </Box>
                            ))}
                        </fieldset>
                        <br/>
                        <br/>
                        <fieldset>
                            <legend>HORAS PENDIENTES</legend>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>HORAS SIMPLES</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.horasSimples.horasTotal} minutos</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>HORAS INHABILES</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.horasInhabile.horasTotal} minutos</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <br/>
                        <br/>
                        <fieldset>
                            <legend>DIAS PENDIENTES</legend>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>ENFERMEDAD FAMILIAR</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.enfermedadFamiliar.diasTotal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>ESTUDIO / (EXAMEN, PARCIAL)</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.estudio.diasTotal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>DIAS INHABILES / TURISMO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.diasTurismo.diasTotal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>ACTA 1694</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.acta.diasTotal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>INTERNACION FAMILIAR</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.internacion.diasTotal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>LEY 17242</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.ley.diasTotal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={1}>
                                            
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>LICENCIA ESPECIAL 30 AÑOS</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.especial.diasTotal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>LICENCIA EX. COVID</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.covid.diasTotal}</Item>
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <br/>
                        <br/>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                        <br/>
                        <br/>
                    </Container>
                :
                    <Redirect to='login'/>
                }
            </>
        )//Final return
    }//Final render

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            atras: true,
        })
    }
}

export default ConsultasSaldosUsuario